<template>
  <div>
    <message :messages="messages"></message>
    <v-card>
      <v-card-title>
        <div>
          <h3 class="headline">{{labels.clmReserves}} for {{claimForm.selectedClaimant.clmtName}}, Item No. {{claimForm.selectedClmItem.clmItemNo}}</h3>
        </div>
        <v-spacer></v-spacer>
        <div>
          <v-autocomplete v-model="addReserve" v-if="hasAddableReserve" :items="addableReserve" label="Add Reserve" item-text="label" item-value="key" prepend-icon="mdi-playlist-plus" outline @change="doAddReserve" clearable></v-autocomplete>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-sm v-if="claimParam.reserveInit === 1 && reserve.length > 0">
          <v-layout row wrap v-for="reserve in claimForm.submitReserve" :key="reserve.key" align-center>
            <v-flex xs2>
              <v-subheader class="queryLabel">{{getParamReserve(reserve.key).value}}</v-subheader>
            </v-flex>
            <v-flex xs4>
              <v-subheader class="queryLabel">{{getParamReserve(reserve.key).label}}</v-subheader>
            </v-flex>
            <v-flex xs5>
              <v-text-field class="mavPrefix" :prefix="'S$'" v-num-mask="{negative: true}" v-model="reserve.value" :error-messages="errors.collect(reserve.key)" :name="reserve.key" :data-vv-name="reserve.key" :data-vv-as="getParamReserve(reserve.key).label" v-validate="{ required: true, mask_decimal:2, mask_max_value: 99999999.99, res_amt_pne: getParamReserve(reserve.key).resAmtPNE}"></v-text-field>
            </v-flex>
            <v-flex xs1>
              <v-tooltip top>
                <v-btn flat icon color="red" slot="activator" @click="removeReserve(reserve.key)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <span>Remove Reserve</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="claimForm.submitReserve.length <= 0">
            <v-flex xs12>
              There is no Reserve added
            </v-flex>
          </v-layout>
        </v-container>
        <v-layout row wrap v-else-if="claimParam.reserveInit === 1 && reserve.length <= 0">
          <v-flex xs12>
            No Reserve found
          </v-flex>
        </v-layout>
        <loader v-else :card="false" :height="300" :init="doGetReserve" loadText="Loading Reserve" errorText="Failed to load Reserve" :loading="claimParam.reserveInit === 0"></loader>
      </v-card-text>
    </v-card>
    <v-layout row wrap class="mt-3">
      <v-spacer></v-spacer>
      <v-btn round color="secondary" @click.prevent="doAddClmItem">
        Add Claim Item
        <v-icon right dark>mdi-playlist-plus</v-icon>
      </v-btn>
      <v-btn round color="primary" @click.prevent="doProceed">
        Proceed to Summary
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { CLAIMS_CLAIMDETAIL_LIFECYCLE, CLAIMS_CLAIMDETAIL_CLAIMRESERVE } from '@/store/types'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import clone from 'clone'
import { formatDisplayDate } from '@/utils/date'
import { SaveClaimMixin } from '../saveClaimMixin'

export default {
  data() {
    return {
      labels: {
        clmReserves: 'Claim Reserves'
      },
      claimForm: {
        submitReserve: [],
        selectedClaimant: undefined,
        selectedClmItem: undefined
      },
      reserve: [],
      nol1Loading: false,
      nol2Loading: false,
      addReserve: undefined
    }
  },
  computed: {
    globalCommonForm() {
      return this.$store.state.claims.claimDetail.commonForm
    },
    globalClaimForm() {
      return this.$store.state.claims.claimDetail.claimForm
    },
    claimParam() {
      return this.$store.state.claims.claimDetail.claimParam
    },
    addableReserve() {
      let result = []
      result = this.reserve
      if (result && result.length > 0) {
        // Remove those that already exist in local form
        result = result.filter(reserve => {
          for (let localReserve of this.claimForm.submitReserve) {
            if (localReserve.key === reserve.key) {
              return false
            }
          }
          return true
        })
      }
      return result
    },
    hasAddableReserve() {
      if (this.addableReserve.length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    'reserve': {
      handler: function (values) {
        this.$emit('input', values)
      },
      deep: true,
      immediate: true
    },
    'claimParam.reserveInit': function (value) {
      if (value === 1) {
        this.initReserve()
      }
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      this.claimForm.selectedClaimant = this.globalClaimForm.selectedClaimant
      this.claimForm.selectedClmItem = this.globalClaimForm.selectedClmItem
      if (this.claimParam.reserveInit !== 1) {
        this.doGetReserve()
      } else {
        this.initReserve()
      }
    },
    initReserve() {
      this.reserve = []
      if (this.globalClaimForm.clmReserves && this.globalClaimForm.clmReserves.length > 0) {
        this.$set(this, 'reserve', clone(this.globalClaimForm.clmReserves))
      }
      if (this.claimForm.selectedClmItem.clmReserves && this.claimForm.selectedClmItem.clmReserves.length > 0) {
        this.claimForm.submitReserve = clone(this.claimForm.selectedClmItem.clmReserves)
      } else {
        this.claimForm.submitReserve = []
      }
    },
    doGetReserve() {
      this.$store.dispatch('claimReserve', { busCls: this.globalCommonForm.busCls })
    },
    getParamReserve(key) {
      for (let paramReserve of this.claimParam.reserve) {
        if (paramReserve.value === key) {
          return paramReserve
        }
      }
      return {}
    },
    removeReserve(reserve) {
      this.claimForm.submitReserve.splice(this.claimForm.submitReserve.indexOf(this.claimForm.submitReserve.find(x => x.key === reserve)), 1)
      this.addReserve = undefined
    },
    doAddReserve() {
      if (this.addReserve) {
        const reserve = this.addableReserve.find(x => x.key === this.addReserve)
        if (reserve) {
          this.claimForm.submitReserve.push({
            clmtNo: this.claimForm.selectedClaimant.clmtNo,
            clmItemNo: this.claimForm.selectedClmItem.clmItemNo,
            key: reserve.key,
            value: reserve.value
          })
        }
        this.addReserve = null
      }
    },
    doAddClmItem() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(CLAIMS_CLAIMDETAIL_CLAIMRESERVE, this.claimForm)
          this.$store.commit(CLAIMS_CLAIMDETAIL_LIFECYCLE, 2)
          this.$router.push({ name: 'claimDetailItem' })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(CLAIMS_CLAIMDETAIL_CLAIMRESERVE, this.claimForm)
          this.$store.commit(CLAIMS_CLAIMDETAIL_LIFECYCLE, 4)
          this.$router.push({ name: 'claimDetailSummary' })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        this.$store.commit(CLAIMS_CLAIMDETAIL_CLAIMRESERVE, this.claimForm)
        await this.$store.dispatch('saveClaim')
        return true
      } catch (err) {
        return false
      }
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    }
  },
  beforeMount() {
    // Check claim lifecycle (might be using back link or url)
    if (this.$store.state.claims.claimDetail.claimLifeCycle !== 3) {
      this.$store.commit(CLAIMS_CLAIMDETAIL_LIFECYCLE, 3)
    }
    this.doInit()
  },
  created() {
    this.claimForm.selectedClaimant = this.globalClaimForm.selectedClaimant
    this.claimForm.selectedClmItem = this.globalClaimForm.selectedClmItem
    this.$validator.extend('res_amt_pne', {
      getMessage(field, args) {
        if (args === void 0) args = []
        var resAmtPNE = args[0]
        if (resAmtPNE) {
          if (resAmtPNE === 'P') {
            // Value must be Positive
            return `${field} value must be Positive.`
          } else if (resAmtPNE === 'N') {
            // Value must be Positive
            return `${field} value must be Negative.`
          } else {
            return ''
          }
        } else {
          return ''
        }
      },
      validate(value, args) {
        if (value) {
          value = '' + value // If a format other den str, it doesnt has replace
          const valueWithoutMask = value.replace(/,/g, '')
          if (args === void 0) args = []
          var resAmtPNE = args[0]
          if (resAmtPNE) {
            if (resAmtPNE === 'P') {
              // Value must be Positive
              if (valueWithoutMask < 0) {
                return false
              } else {
                return true
              }
            } else if (resAmtPNE === 'N') {
              // Value must be Positive
              if (valueWithoutMask > 0) {
                return false
              } else {
                return true
              }
            } else return true
          } else return true
        } else return true
      }
    })
  },
  mixins: [
    MessageMixin,
    TableConst.default,
    SaveClaimMixin
  ]
}
</script>

<style lang="scss">
</style>
